import { FC } from 'react';
import { PrepaidLaws } from './PrepaidLaws/PrepaidLaws';

export const PrepaidLawsPage: FC = () => {
  return <PrepaidLaws />;
};
